const CONTEXT_KEY = "loadevo.test.context";
const OPS_TOKEN_KEY = "loadevo.ops.token";
const OPS_USER_KEY = "loadevo.ops.user";

export function isTestAppHost() {
  return (
    typeof window !== "undefined" &&
    window.location.hostname === "test-app.loadevo.com"
  );
}

export function getAuthContext() {
  if (!isTestAppHost()) return "billing";

  return sessionStorage.getItem(CONTEXT_KEY) === "ops"
    ? "ops"
    : "billing";
}

export function setAuthContext(context) {
  if (!isTestAppHost()) return;

  sessionStorage.setItem(
    CONTEXT_KEY,
    context === "ops" ? "ops" : "billing"
  );
}

export function saveStoredAuth(token, user, keepSignedIn) {
  const isOps = getAuthContext() === "ops";

  const tokenKey = isOps ? OPS_TOKEN_KEY : "token";
  const userKey = isOps ? OPS_USER_KEY : "user";

  const destination = keepSignedIn
    ? localStorage
    : sessionStorage;

  const other = keepSignedIn
    ? sessionStorage
    : localStorage;

  destination.setItem(tokenKey, token);
  destination.setItem(userKey, JSON.stringify(user || {}));

  other.removeItem(tokenKey);
  other.removeItem(userKey);
}

export function getStoredToken() {
  if (getAuthContext() === "ops") {
    return (
      sessionStorage.getItem(OPS_TOKEN_KEY) ||
      localStorage.getItem(OPS_TOKEN_KEY) ||
      ""
    );
  }
  return (
    sessionStorage.getItem(
      "token"
    ) ||
    localStorage.getItem(
      "token"
    ) ||
    sessionStorage.getItem(
      "auth_token"
    ) ||
    localStorage.getItem(
      "auth_token"
    ) ||
    ""
  );
}

export function getStoredUser() {
  if (getAuthContext() === "ops") {
    const raw =
      sessionStorage.getItem(OPS_USER_KEY) ||
      localStorage.getItem(OPS_USER_KEY);

    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  const candidates = [
    sessionStorage.getItem(
      "user"
    ),

    localStorage.getItem(
      "user"
    ),

    sessionStorage.getItem(
      "auth_user"
    ),

    localStorage.getItem(
      "auth_user"
    ),
  ];

  for (
    const raw of
    candidates
  ) {
    if (!raw) {
      continue;
    }

    try {
      const parsed =
        JSON.parse(
          raw
        );

      if (
        parsed &&
        typeof parsed ===
          "object"
      ) {
        return parsed;
      }
    } catch {
      // Try the next stored value.
    }
  }

  return null;
}

export function clearStoredAuth() {
  if (getAuthContext() === "ops") {
    sessionStorage.removeItem(OPS_TOKEN_KEY);
    sessionStorage.removeItem(OPS_USER_KEY);

    localStorage.removeItem(OPS_TOKEN_KEY);
    localStorage.removeItem(OPS_USER_KEY);

    return;
  }

  sessionStorage.removeItem(
    "token"
  );

  sessionStorage.removeItem(
    "user"
  );

  sessionStorage.removeItem(
    "auth_token"
  );

  sessionStorage.removeItem(
    "auth_user"
  );

  localStorage.removeItem(
    "token"
  );

  localStorage.removeItem(
    "user"
  );

  localStorage.removeItem(
    "auth_token"
  );

  localStorage.removeItem(
    "auth_user"
  );
}